import React from 'react';

export default function BrandMark({ compact = false }) {
  return <span className={`brand-mark${compact ? ' compact' : ''}`} aria-hidden="true"><span>DRINK</span><span className="brand-bridge">IF YOU</span><span>THINK</span></span>;
}
